import { CompareListStatusItem, WishlistCheckboxItem } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from './notification-template-factory-types';

export const notificationTemplateFactory = {
  [NotificationTemplates.WishList]: WishlistCheckboxItem,
  [NotificationTemplates.Compare]: CompareListStatusItem,
};
